import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Divider, Space } from 'antd';
import { FilterActionsWrapper, FilterOptionsWrapper } from 'ui/Filter';

function CheckboxFilter({ filter, filters, onFilterChange }) {
  const [selectedFilter, setSelectedFilter] = useState('');

  useEffect(() => {
    setSelectedFilter(filter);
  }, [filter]);

  const handleChange = (event, value) => {
    const { checked } = event.target;

    if (checked) {
      setSelectedFilter(value);
    } else {
      setSelectedFilter('');
    }
  };

  const handleFilter = () => {
    if (!selectedFilter) {
      return;
    }

    onFilterChange(selectedFilter);
  };

  const handleClear = () => {
    setSelectedFilter('');
    onFilterChange('');
  };

  return (
    <>
      <FilterOptionsWrapper>
        <Space direction="vertical">
          {filters.map(({ text, value }) => (
            <Checkbox
              checked={value === selectedFilter}
              onChange={(e) => handleChange(e, value)}
            >
              {text}
            </Checkbox>
          ))}
        </Space>
      </FilterOptionsWrapper>

      <Divider style={{ margin: '0' }} />

      <FilterActionsWrapper>
        <Space>
          <Button
            type="link"
            size="small"
            disabled={!selectedFilter}
            onClick={handleClear}
          >
            Сбросить
          </Button>
          <Button type="primary" size="small" onClick={handleFilter}>
            ОК
          </Button>
        </Space>
      </FilterActionsWrapper>
    </>
  );
}

export { CheckboxFilter };
